import React from 'react';

import { useSettings } from '@wix/tpa-settings/react';
import s from './ProductVariants.scss';
import { classes } from './ProductVariants.st.css';
import { useControllerProps } from '../../ControllerContext';
import settingsParams from '../../../settingsParams';
import { BoxSelection, BoxSelectionBoxSize } from '@wix/wix-ui-tpa';
import { useState } from '../../stores';

export enum ProductVariantsDataHooks {
  variants = 'ProductVariants.variants',
}

const ProductVariants = () => {
  const {
    state: { checkout },
    dispatch,
  } = useState();
  const settings = useSettings();
  const {
    presetVariants,
    currencyCode,
    locale,
    customVariantDisplay,
    customVariant,
  } = useControllerProps().giftCardStore;
  const { creatingCheckout, addingToCart } =
    useControllerProps().giftCardCheckoutStore;

  const variantDisplay = (value: number) => {
    if (customVariantDisplay) {
      return customVariantDisplay.replace('{value}', value.toString());
    }
    return formatCurrency(value);
  };

  const formatCurrency = (value: number) => {
    try {
      const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });

      return formatter.format(value);
    } catch (error) {
      return value.toString();
    }
  };

  const variantsOptions = () => {
    return presetVariants.map((variant) => (
      <BoxSelection.Option
        className={s.BoxSelectionAmountSelectorOption}
        disabled={
          checkout.purchaseOptions.variantId !== variant.id &&
          (creatingCheckout || addingToCart)
        }
        id={variant.id}
        key={variant.id}
        checked={checkout.purchaseOptions.variantId === variant.id}
      >
        {variantDisplay(Number(variant.value))}
      </BoxSelection.Option>
    ));
  };

  const customVariantOption = () => (
    <BoxSelection.Option
      id="custom"
      disabled={
        checkout.purchaseOptions.variantId !== 'custom' &&
        (creatingCheckout || addingToCart)
      }
      className={s.BoxSelectionAmountSelectorOption}
      checked={checkout.purchaseOptions.variantId === 'custom'}
    >
      {settings.get(settingsParams.otherAmountVariantLabel)}
    </BoxSelection.Option>
  );

  return (
    <fieldset
      className={s.variants}
      data-hook={ProductVariantsDataHooks.variants}
    >
      <legend className={s.label} style={{ position: 'relative' }}>
        {settings.get(settingsParams.amountLabel)}
      </legend>
      <BoxSelection
        data-hook="rise-gift-card-product-variants-box-selection"
        inline
        className={classes.boxSelectionAmountSelectorOption}
        name="variants-selection"
        size={BoxSelectionBoxSize.small}
        onChange={({ id }) =>
          dispatch({
            type: 'setPurchaseOptions',
            payload: {
              variantId: id,
            },
          })
        }
      >
        {variantsOptions()}
        {customVariant ? customVariantOption() : ''}
      </BoxSelection>
    </fieldset>
  );
};

export default ProductVariants;
